import { Actions } from './license-types.actions'
import { fromJS } from 'immutable'
import * as LicenseTypesTypes from './license-types.types'

export const initialState = fromJS({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page: 1,
      page_size: 10,
    },
    total: 0,
    results: 0,
  },
  createLicenseType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateLicenseType: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
})

export function licenseTypesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case LicenseTypesTypes.UPDATE_LICENSE_TYPE_REQUEST: {
      return state.setIn(['updateLicenseType', 'isLoading'], true)
    }

    case LicenseTypesTypes.UPDATE_LICENSE_TYPE_SUCCESS: {
      return state.setIn(['updateLicenseType', 'isLoading'], false)
    }

    case LicenseTypesTypes.UPDATE_LICENSE_TYPE_FAILURE: {
      return state.setIn(['updateLicenseType', 'isLoading'], false)
    }

    case LicenseTypesTypes.CREATE_LICENSE_TYPE_REQUEST: {
      return state.setIn(['createLicenseType', 'isLoading'], true)
    }

    case LicenseTypesTypes.CREATE_LICENSE_TYPE_SUCCESS: {
      return state.setIn(['createLicenseType', 'isLoading'], false)
    }

    case LicenseTypesTypes.CREATE_LICENSE_TYPE_FAILURE: {
      return state.setIn(['createLicenseType', 'isLoading'], false)
    }

    case LicenseTypesTypes.DELETE_LICENSE_TYPE_REQUEST: {
      return state
    }

    case LicenseTypesTypes.DELETE_LICENSE_TYPE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case LicenseTypesTypes.DELETE_LICENSE_TYPE_FAILURE: {
      return state
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPE_REQUEST: {
      return state.setIn(['updateLicenseType', 'isLoading'], true)
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPE_SUCCESS: {
      return state
        .setIn(['updateLicenseType', 'isLoading'], false)
        .setIn(['updateLicenseType', 'data'], fromJS(action.payload))
    }

    case LicenseTypesTypes.FETCH_LICENSE_TYPE_FAILURE: {
      return state.setIn(['updateLicenseType', 'isLoading'], false)
    }

    case LicenseTypesTypes.FETCH_DEFAULT_PREFIX_REQUEST: {
      return state
    }

    case LicenseTypesTypes.FETCH_DEFAULT_PREFIX_SUCCESS: {
      return state.setIn(
        ['createLicenseType', 'data', 'codePrefix'],
        action.payload.prefix,
      )
    }

    case LicenseTypesTypes.FETCH_DEFAULT_PREFIX_FAILURE: {
      return state
    }

    case LicenseTypesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case LicenseTypesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
